import { render, staticRenderFns } from "./nav-logical.vue?vue&type=template&id=0f675ebb&scoped=true&"
import script from "./nav-logical.vue?vue&type=script&lang=ts&"
export * from "./nav-logical.vue?vue&type=script&lang=ts&"
import style0 from "./nav-logical.vue?vue&type=style&index=0&id=0f675ebb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f675ebb",
  null
  
)

export default component.exports